import isEmpty from 'lodash/isEmpty';

import { formatPeriodLabel, parseDate } from 'common/utils/dates';

export const getElectricBillPerMonths = ({ isBimonthly = false, items }) => {
    if (!items || isEmpty(items)) return [];

    return items.map((item) => {
        const label = formatPeriodLabel({
            finalDate: parseDate(item.final_date, 'yyyy-MM-dd'),
            isBimonthly,
        });

        return {
            id: Math.random(),
            label,
            url: item.file_url,
            urlType: item.url_type ?? 1,
        };
    });
};
